import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=159fa54b&scoped=true&"
import script from "./Score.vue?vue&type=script&lang=ts&"
export * from "./Score.vue?vue&type=script&lang=ts&"
import style0 from "./Score.vue?vue&type=style&index=0&id=159fa54b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159fa54b",
  null
  
)

export default component.exports